import { memo } from 'react';
import { Handle, type NodeProps, Position } from 'reactflow';
// Import UI Components
import BaseBlock from './Base.block';

const TargetBlock: React.FC<NodeProps> = (props) => {
    const { sourcePosition, id } = props;

    return (
        <div className="crm-flow-editor-block">
            <Handle type="source" position={sourcePosition ?? Position.Right} id={`${id}_source`} />
            <BaseBlock node={props} />
        </div>
    );
};

export default memo(TargetBlock);
